import useQuery from "./useQuery";

export default function useApiFetch() {
    const query = useQuery();
    
    return async (path, params) => {
        const headers = { "Content-Type": "application/json" };

        // Try to get JWT from URL first, then from sessionStorage
        let jwt = query.get("jwt");
        if (jwt) {
            // Store JWT in sessionStorage for subsequent requests
            sessionStorage.setItem("jwt", jwt);
        } else {
            // Get JWT from sessionStorage if not in URL
            jwt = sessionStorage.getItem("jwt");
        }

        // Add JWT to both header and body for maximum compatibility
        const bodyParams = { ...params };
        if (jwt) {
            console.log("🔑 JWT found, adding to request:", jwt.substring(0, 20) + "...");
            headers.Authorization = `Bearer ${jwt}`;
            bodyParams.jwt = jwt; // Also add to body as fallback
        } else {
            console.log("❌ No JWT found in URL or sessionStorage");
        }

        let body = JSON.stringify(bodyParams);

        // Also try adding JWT as URL parameter as final fallback
        let url = `/api/${path}`;
        if (jwt) {
            url += `?jwt=${encodeURIComponent(jwt)}`;
        }

        console.log("🌐 Making request to:", url);
        console.log("📤 Request body:", body);
        
        let res;
        try {
            res = await fetch(url, {
                method: "POST",
                headers,
                body,
            });
            console.log("📥 Response status:", res.status, res.statusText);
        } catch (fetchError) {
            console.error("❌ Fetch error:", fetchError);
            throw new Error(`Network error: ${fetchError.message}`);
        }

        let data;
        try {
            data = await res.json();
            console.log("📋 Response data:", data);
        } catch (jsonError) {
            console.error("❌ JSON parse error:", jsonError);
            // Try to get response as text if JSON parsing fails
            try {
                const responseText = await res.text();
                console.log("📄 Response as text:", responseText);
                data = { message: responseText || `HTTP ${res.status} ${res.statusText}` };
            } catch (textError) {
                console.error("❌ Text parse error:", textError);
                data = { message: `HTTP ${res.status} ${res.statusText}` };
            }
        }

        let statusText;
        if (data?.message) {
            statusText = data?.message;
        } else if (res.statusText) {
            statusText = res.statusText;
        } else {
            statusText = `Server Response: ${res.status}`;
        }

        return {
            status: res.status,
            statusText,
            data,
        };
    };
}
